import i18n from "@Shared/@i18n";
import moment from "moment";
export const reminderClassificationStatusMap = {
  "past-due": {
    cssClass: "text-danger",
    text: timeAgo => i18n.tc("boards.remindersClassifications.past-due", 2, {
      timeAgo
    }).toLowerCase()
  },
  active: {
    cssClass: "text-success-darker bold",
    text: () => i18n.t("boards.remindersClassifications.active").toLowerCase()
  },
  upcoming: {
    cssClass: "text-gray",
    text: timeAgo => i18n.tc("boards.remindersClassifications.upcoming", 2, {
      timeAgo
    })
  },
  planned: {
    cssClass: "text-gray",
    text: timeAgo => i18n.tc("boards.remindersClassifications.planned", 2, {
      timeAgo
    })
  }
};
export const activityStateParser = hoursDiff => {
  if (hoursDiff < 0) {
    return "past-due";
  } else if (hoursDiff <= 24) {
    return "active";
  } else if (hoursDiff <= 14 * 24) {
    return "upcoming";
  } else {
    return "planned";
  }
};
export const getActivityState = (scheduledDate, scheduledTime) => {
  const scheduledDateTime = `${scheduledDate} ${scheduledTime}`;
  const _moment = moment(scheduledDateTime, "YYYY-MM-DD HH:mm:ss");
  const timeAgo = _moment.fromNow(true);
  const isToday = _moment.isSame(new Date(), "day");
  const isFuture = _moment.isAfter();
  const isPast = _moment.isBefore() && !isToday;
  const isTodayAndFuture = isToday && isFuture;
  let activityState = "planned";
  if (isPast) {
    activityState = "past-due";
  } else if (isTodayAndFuture) {
    activityState = "active";
  } else if (isToday) {
    activityState = "past-due";
  } else if (isFuture) {
    activityState = "upcoming";
  }
  const {
    cssClass,
    text
  } = reminderClassificationStatusMap[activityState];
  return {
    key: activityState,
    cssClass,
    text: text(timeAgo)
  };
};
export const parseReminderClassificationTimeAgo = (scheduledDate, scheduledTime, getObject = false) => {
  return getObject ? getActivityState(scheduledDate, scheduledTime) : getActivityState(scheduledDate, scheduledTime).text;
};
export const parseReminderClassificationClass = (scheduledDate, scheduledTime) => {
  return getActivityState(scheduledDate, scheduledTime).cssClass;
};